import { PageCriteriaDTO } from '@dto/PageCriteriaDTO';

export class StatisticPageCriteriaDTO extends PageCriteriaDTO {
  public year: number;

  public month: string;
}